import { useViewport } from 'hooks/3catinfo/useViewport';
import Mosaic from '../../Mosaic';
import Camera from '../Camera';

const getColumns = (viewport, typesViewport) => {
    switch (viewport) {
        case typesViewport.VP_SMALL_MOBILE:
        case typesViewport.VP_MOBILE:
            return 1;
        case typesViewport.VP_SMALL:
            return 2;
        default:
            return 3;
    }
};

const LlistatCameres = (props) => {
    const { titol, items } = props;
    const { viewport, typesViewport } = useViewport();
    return items ? (
        <div>
            <Mosaic titol={titol} numColumns={getColumns(viewport, typesViewport)} hGap={300} vGap={400}>
                {items?.map((item, index) => {
                    return (
                        <div key={`camera-content-${index}`}>
                            <Camera item={item} index={index} items={items} />
                        </div>
                    );
                })}
            </Mosaic>
        </div>
    ) : (
        <></>
    );
};

export default LlistatCameres;
